export default __webpack_public_path__ + "static/media/rightArrowCircle.b81f00a2.svg";